export default __webpack_public_path__ + "static/media/transfacil_galery_14.16df6e33.jpg";